import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import NavigationBarGeneral from "../components/navigation-bar-general";
import Footer from "../components/footer";
import "./terms-of-service.css";

const TermsOfService = () => {
  return (
    <div className="terms-of-service-container">
      <Helmet>
        <title>Terms of Service | CashOver Pay | Lebanon</title>
        <meta
          name="description"
          content="Read the CashOver Terms of Service and Privacy Policy to understand your rights and responsibilities while using our secure digital wallet."
        />
        <meta
          property="og:title"
          content="Terms of Service | CashOver | Secure Digital Wallet"
        />
        <meta
          property="og:description"
          content="Read the CashOver Terms of Service and Privacy Policy to understand your rights and responsibilities while using our secure digital wallet."
        />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_SITE_URL}/icon.webp`}
        />
      </Helmet>

      <NavigationBarGeneral
        text={
          <Fragment>
            <span className="terms-of-service-text10">CASHOVER</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="terms-of-service-text11">by overlab.io</span>
          </Fragment>
        }
        rootClassName="navigation-bar-generalroot-class-name6"
      />

      <div className="terms-of-service-column">
        <h2 className="terms-of-service-text12">
          CashOver Terms of Service & Privacy Policy
        </h2>
        <h1 className="terms-of-service-text13">Terms & Policies</h1>

        <div className="info">
          <p>
            <strong>Effective Date:</strong> 25 September 2025
          </p>
          <p>
            <strong>Company:</strong> OVERLAB S.A.R.L
          </p>
          <p>
            <strong>Contact:</strong> contactus@overlab.io
          </p>
        </div>

        <p className="terms-of-service-text14">
          <span>
            Welcome to CashOver. By accessing or using our services — CashOver
            Personal, CashOver Merchant, CashOver Business, and DropOver
            (collectively, "Services") — you agree to comply with these Terms of
            Service and Privacy Policy. If you do not agree, please refrain from
            using our Services.
          </span>

          <br />
          <br />
          <span className="terms-of-service-text18">1. Eligibility</span>
          <br />
          <br />
          <span>
            - You must be at least 18 years old or the legal age in your
            jurisdiction to use our Services.
          </span>
          <br />
          <span>
            - You must provide accurate and complete information during account
            registration and KYC verification.
          </span>

          <br />
          <br />
          <span className="terms-of-service-text18">2. Services Overview</span>
          <br />
          <br />
          <strong>2.1 CashOver Personal (Mobile Only)</strong>
          <ul>
            <li>
              Send and receive money in LBP, USD, or USDT using cashtag, phone
              number, or QR code.
            </li>
            <li>Deposit and withdrawal management.</li>
            <li>KYC Verification.</li>
            <li>Payments via our SDK or in-person QR scan.</li>
            <li>Pay for DropOver orders using CashOver Personal.</li>
          </ul>

          <strong>2.2 CashOver Merchant (Mobile and Web)</strong>
          <ul>
            <li>Receive payments in USD or LBP via SDK or webhooks.</li>
            <li>Deposit and withdrawal management.</li>
            <li>Menu management for items, offers, and categories.</li>
            <li>Analytics and sales reports.</li>
          </ul>

          <strong>2.3 CashOver Business (Web)</strong>
          <ul>
            <li>
              Receive and make payments in USD or LBP via SDK, webhooks, or QR
              code.
            </li>
            <li>Deposit and withdrawal management.</li>
            <li>Employee management system.</li>
            <li>
              Advanced payroll system (employees must use CashOver Personal).
            </li>
            <li>Income analysis and tax reporting tools.</li>
          </ul>

          <strong>2.4 DropOver (Mobile and Web)</strong>
          <ul>
            <li>Access merchant menus and catalogs.</li>
            <li>Pay using CashOver Personal or cash.</li>
          </ul>

          <br />
          <span className="terms-of-service-text18">3. User Obligations</span>
          <ul>
            <li>Provide accurate information during registration and KYC.</li>
            <li>Use the Services in compliance with applicable laws.</li>
            <li>Refrain from fraudulent or unlawful activity.</li>
            <li>
              Maintain account confidentiality and notify us of unauthorized
              access.
            </li>
          </ul>

          <br />
          <span className="terms-of-service-text18">
            4. Privacy & Data Collection
          </span>
          <ul>
            <li>
              Data collection is limited to what is necessary for service
              functionality.
            </li>
            <li>
              CashOver Personal may request access to contacts to facilitate
              phone number transfers; this is optional and ephemeral.
            </li>
            <li>
              Data is used to provide, maintain, and improve Services, comply
              with law, and prevent fraud.
            </li>
            <li>
              Data is not sold. Sharing occurs only with payment processors for
              transactions.
            </li>
            <li>
              Reasonable security measures are in place to protect your data.
            </li>
          </ul>

          <br />
          <span className="terms-of-service-text18">
            5. Transactions & Payments
          </span>
          <ul>
            <li>Transactions are processed by the selected payment method.</li>
            <li>Fees are disclosed before completion.</li>
            <li>Refunds follow our internal policies and applicable law.</li>
            <li>
              Users are responsible for resolving chargebacks with customers.
            </li>
          </ul>

          <br />
          <span className="terms-of-service-text18">
            6. Intellectual Property
          </span>
          <p>
            All content, software, logos, and trademarks are owned by CashOver
            or licensed to us. You may not copy, modify, or distribute any part
            of the Services without written permission.
          </p>

          <br />
          <span className="terms-of-service-text18">7. Termination</span>
          <ul>
            <li>
              We may suspend or terminate your account for violations or
              unlawful activity.
            </li>
            <li>You may close your account at any time.</li>
            <li>
              Termination does not affect obligations for completed transactions
              or accrued rights.
            </li>
          </ul>

          <br />
          <span className="terms-of-service-text18">
            8. Limitation of Liability
          </span>
          <p>
            CashOver is not liable for indirect, incidental, or consequential
            damages. We are not responsible for errors, delays, or unauthorized
            access outside our control.
          </p>

          <br />
          <span className="terms-of-service-text18">
            9. Governing Law & Dispute Resolution
          </span>
          <p>
            These Terms are governed by the laws of Lebanon. Disputes are
            resolved exclusively by the courts of Lebanon.
          </p>

          <br />
          <span className="terms-of-service-text18">
            10. Cookies & Tracking
          </span>
          <p>
            Our apps and websites may use cookies to enhance user experience and
            analyze usage. You can control cookie settings through your device
            or browser.
          </p>

          <br />
          <span className="terms-of-service-text18">
            11. Changes to Terms and Privacy Policy
          </span>
          <p>
            We may update these Terms and Privacy Policy periodically. Updates
            are effective when posted in the app or website. Continued use
            constitutes acceptance.
          </p>

          <br />
          <span className="terms-of-service-text18">12. Contact Us</span>
          <p>
            Questions or concerns? Contact us at contactus@overlab.io,
            Lebanon.
          </p>

          <br />
          <span className="terms-of-service-text98">
            Date of Last Revision: 25 September 2025
          </span>
        </p>
      </div>

      <Footer rootClassName="footerroot-class-name1" />
    </div>
  );
};

export default TermsOfService;
